import { useState } from 'react'
import { Space, Row, Col, Form, notification, DatePicker } from 'antd'
import { useAsync } from 'react-use'
import { useStoreState } from 'easy-peasy'
import _ from 'lodash'
import xlsx from 'json-as-xlsx'

import PivotTable from 'components/PivotTable'
import Page from 'components/Page'
import SearchOrganization from 'components/SearchOrganization'
import Button from 'components/Button'
import Card from 'components/Card'
import FilterReportStatusSelect from 'components/FilterReportStatusSelect'
import FilterReportTypeSelect from 'components/FilterReportTypeSelect'
import FilterRiskOwnerSelect from 'components/FilterRiskOwnerSelect'
// import FilterImpactTypeSelect from 'components/FilterImpactTypeSelect'

import { useTranslate } from 'hooks/translate'

import { getIncidentDashboardApi } from 'services/incident'
import { getRiskMatrixApi } from 'services/riskMatrix'
// import { getDictionaryValueFilterListApi } from 'services/filter/dictionary/value'

import { convertOrganizationalStructureToFilters } from 'utils/organization'
import moment from 'utils/moment'

import Styled from './styled'

export default function PageMonthlyReport () {
  const { t } = useTranslate()

  const [dataSource, setDataSource] = useState([])
  const [loading, setLoading] = useState(false)
  const [reportMatrixValues, setReportMatrixValues] = useState([])
  // const [dictionaryValues, setDictionaryValues] = useState([])

  // const [filters, setFilters] = useState({
  //   is_significant: null,
  //   risk_level_id: null,
  //   impact_type_id: null,
  //   report_type_id: null,
  //   report_status_id: null,
  //   assignee_id: null,
  //   reporter_company_id: null,
  //   reporter_group_id: null,
  //   reporter_bu_id: null,
  //   reporter_division_id: null,
  //   reporter_department_id: null,
  //   reporter_section_id: null,
  //   risk_co_company_id: null,
  //   risk_co_group_id: null,
  //   risk_co_bu_id: null,
  //   risk_co_division_id: null,
  //   risk_co_department_id: null,
  //   risk_co_section_id: null,
  //   risk_owner_company_id: null,
  //   risk_owner_group_id: null,
  //   risk_owner_bu_id: null,
  //   risk_owner_division_id: null,
  //   risk_owner_department_id: null,
  //   risk_owner_section_id: null,
  //   date_from: null,
  //   date_to: null,
  // })

  // const riskLevels = useStoreState((state) => state.filter.riskLevels)
  const impactTypes = useStoreState((state) => state.filter.impactTypes)
  const dataTypes = useStoreState((state) => state.filter.dataTypes)
  const riskOwners = useStoreState((state) => state.filter.riskOwners)
  // const dictionaries = useStoreState((state) => state.filter.dictionaries)
  // const reportTypes = useStoreState((state) => state.filter.reportTypes)
  // const reportStatuses = useStoreState((state) => state.filter.reportStatuses)

  const valueDataTypes = _.filter(dataTypes, (dataType) => {
    return _.includes(['integer', 'float', 'calculation'], dataType?.name)
  })

  const valueDataTypeIds = _.map(valueDataTypes, (valueDataType) => valueDataType?.id)

  useAsync(async () => {
    if (!_.isEmpty(impactTypes)) {
      await Promise.all(
        _.map(impactTypes, async (impactType) => {
          return await getRiskMatrixApi(impactType?.value_list_id, {}).then((res) => res.data)
        })
      ).then((valuesLoop) => {
        const mergeValues = []
        _.forEach(valuesLoop, (values) => {
          mergeValues.push(...values)
        })
        setReportMatrixValues(mergeValues)
      })
    }
  }, [impactTypes])

  // useAsync(async () => {
  //   if (!_.isEmpty(dictionaries)) {
  //     await Promise.all(
  //       _.map(dictionaries, async (dictionary) => {
  //         return await getDictionaryValueFilterListApi(dictionary?.id).then((res) => res.data)
  //       })
  //     ).then((valuesLoop) => {
  //       const mergeValues = []
  //       _.forEach(valuesLoop, (values) => {
  //         mergeValues.push(...values)
  //       })
  //       setDictionaryValues(mergeValues)
  //     })
  //   }
  // }, [dictionaries])

  const getImpactLevelName = (impact_level_id) => {
    const reportMatrixValue = _.find(reportMatrixValues, (reportMatrixValue) => {
      return reportMatrixValue?.impact_level_id === impact_level_id
    })
    // const impactType = _.find(impactTypes, {
    //   value_list_id: reportMatrixValue?.impact_level?.impact_type_id,
    // })
    // const name = `${impactType?.value_list_name} ${reportMatrixValue?.impact_level?.report_hd_att_val_name}`
    const name = reportMatrixValue?.impact_level?.report_hd_att_val_name
    if (!name) return null
    return name
  }

  const getLikelihoodLevelName = (likelihood_level_id) => {
    const reportMatrixValue = _.find(reportMatrixValues, (reportMatrixValue) => {
      return reportMatrixValue?.likelihood_level_id === likelihood_level_id
    })
    const name = reportMatrixValue?.likelihood_level?.report_hd_att_val_name
    if (!name) return null
    return name
  }

  const getRiskLevelName = (risk_level_id) => {
    const reportMatrixValue = _.find(reportMatrixValues, (reportMatrixValue) => {
      return reportMatrixValue?.risk_level_id === risk_level_id
    })
    // const impactType = _.find(impactTypes, {
    //   value_list_id: reportMatrixValue?.impact_level?.impact_type_id,
    // })
    // const name = `${impactType?.value_list_name} ${reportMatrixValue?.impact_level?.report_hd_att_val_name} ${reportMatrixValue?.likelihood_level?.report_hd_att_val_name}`
    if (
      !reportMatrixValue?.impact_level?.report_hd_att_val_name &&
      !reportMatrixValue?.likelihood_level?.report_hd_att_val_name
    ) {
      return null
    }
    const name = `${reportMatrixValue?.impact_level?.report_hd_att_val_name} ${reportMatrixValue?.likelihood_level?.report_hd_att_val_name}`
    return name
  }

  const getImpactTypeName = (impact_level_id) => {
    const reportMatrixValue = _.find(reportMatrixValues, (reportMatrixValue) => {
      return reportMatrixValue?.impact_level_id === impact_level_id
    })
    const impactType = _.find(impactTypes, {
      value_list_id: reportMatrixValue?.impact_level?.impact_type_id,
    })
    const name = impactType?.value_list_name
    if (!name) return null
    return name
  }

  const rowData = _.map(dataSource, (data) => {
    const dictionaryReportAttributeValues = _.filter(data?.report_attribute_value, {
      is_dictionary: true,
    })

    const impactLevelBeforeName = getImpactLevelName(data?.impact_level_before_id)
    // const impactLevelAfterName = getImpactLevelName(data?.impact_level_after_id)

    const likelihoodLevelBeforeName = getLikelihoodLevelName(data?.likelihood_level_before_id)
    // const likelihoodLevelAfterName = getLikelihoodLevelName(data?.likelihood_level_after_id)

    const riskLevelBeforeName = getRiskLevelName(data?.risk_level_before_id)
    // const riskLevelAfterName = getRiskLevelName(data?.risk_level_after_id)

    const values = _.filter(data?.report_attribute_value, (reportAttributeValue) => {
      return _.includes(valueDataTypeIds, reportAttributeValue?.report_type_attribute?.data_type_id)
    })

    const objectValues = _.reduce(
      values,
      (r, v, k) => {
        const field = v?.report_type_attribute?.report_type_attribute_name
        const value = Number(v?.report_type_attribute_investigate_value)
        return {
          ...r,
          [field]: value,
        }
      },
      {}
    )

    const objectDictionaries = _.reduce(
      dictionaryReportAttributeValues,
      (r, v, k) => {
        // const dictionaryValue = _.find(dictionaryValues, {
        //   id: v?.report_type_attribute_investigate_value,
        // })
        const field = v?.report_type_attribute?.report_type_attribute_name
        // const value = dictionaryValue?.name
        const value = v?.report_type_attribute_investigate_value
        return {
          ...r,
          [field]: value,
        }
      },
      {}
    )

    const impactTypeName = getImpactTypeName(data?.impact_level_before_id)

    return {
      ...objectDictionaries,
      impact_type: impactTypeName,
      impact_level_before: impactLevelBeforeName,
      // impact_level_after: impactLevelAfterName,
      likelihood_level_before: likelihoodLevelBeforeName,
      // likelihood_level_after: likelihoodLevelAfterName,
      risk_level_before: riskLevelBeforeName,
      // risk_level_after: riskLevelAfterName,
      // risk_owner_business_unit: data?.risk_owner_business_unit?.[0]?.bu_name,
      // risk_owner_company: data?.risk_owner_company?.[0]?.company_name,
      // risk_owner_department: data?.risk_owner_department?.[0]?.department_name,
      // risk_owner_division: data?.risk_owner_division?.[0]?.division_name,
      // risk_owner_group: data?.risk_owner_group?.[0]?.group_name,
      // risk_owner_section: data?.risk_owner_section?.[0]?.section_name,
      risk_owner: _.find(riskOwners, { id: data?.risk_owner_org })?.name,
      report_status: data?.report_status?.report_status_name_en,
      ...objectValues,
    }
  })

  const _list = async (filters) => {
    if (loading) return

    const params = {
      ...filters,
    }

    setLoading(true)

    const res = await getIncidentDashboardApi(params)

    setLoading(false)

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })

      return
    }

    setDataSource(res.data)
  }

  // useAsync(async () => {
  //   _list()
  // }, [filters])

  return (
    <Styled className='page page-monthly-report'>
      <Page title={t('Analysis Report')} showSearch={false}>
        <Space size='middle' direction='vertical' style={{ width: '100%' }}>
          <Form
            layout='horizontal'
            colon={false}
            name='search'
            onFinish={(values) => {
              const reporter = convertOrganizationalStructureToFilters(values.reporter)
              const risk_co = convertOrganizationalStructureToFilters(values.risk_co)
              const risk_owner = convertOrganizationalStructureToFilters(values.risk_owner)

              const newFilters = {
                // ...filters,
                is_significant: values?.is_significant,
                risk_level_id: values?.risk_level_id,
                impact_type_id: values?.impact_type_id,
                report_type_id: values?.report_type_id,
                report_status_id: values?.report_status_id,
                assignee_id: values?.assignee_id,
                date_from: values?.date?.[0] ? moment(values.date[0]).format('YYYY-MM-DD') : null,
                date_to: values?.date?.[1] ? moment(values.date[1]).format('YYYY-MM-DD') : null,
                ..._.reduce(
                  reporter,
                  (result, value, field) => {
                    return {
                      ...result,
                      [`reporter_${field}`]: value,
                    }
                  },
                  {}
                ),
                ..._.reduce(
                  risk_co,
                  (result, value, field) => {
                    return {
                      ...result,
                      [`risk_co_${field}`]: value,
                    }
                  },
                  {}
                ),
                ..._.reduce(
                  risk_owner,
                  (result, value, field) => {
                    return {
                      ...result,
                      [`risk_owner_${field}`]: value,
                    }
                  },
                  {}
                ),
              }

              // setFilters(newFilters)

              _list(newFilters)
            }}
          >
            <Row gutter={8}>
              <Col span={22}>
                <Row gutter={8}>
                  <Col xs={24} lg={12}>
                    <Form.Item labelCol={{ span: 4 }} name='reporter' label='Reporter'>
                      <SearchOrganization />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item name='risk_co' label='Risk Co'>
                      <SearchOrganization />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col xs={24} lg={12}>
                    <Form.Item name='risk_owner' labelCol={{ span: 4 }} label='Risk Owner'>
                      <FilterRiskOwnerSelect />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item name='date' label='Report From - to'>
                      <DatePicker.RangePicker allowClear={false} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      name='report_type_id'
                      labelCol={{ span: 4 }}
                      label='Report Type'
                      rules={[{ required: true }]}
                    >
                      <FilterReportTypeSelect att={{ mode: 'multiple' }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={6}>
                    <Form.Item name='report_status_id' label='Report Status'>
                      <FilterReportStatusSelect att={{ mode: 'multiple' }} />
                    </Form.Item>
                  </Col>
                </Row>
                {/* <Row gutter={8}>
                  <Col span={8}>
                    <Form.Item
                      name="impact_type_id"
                      labelCol={{ span: 6 }}
                      label="Impact Type"
                      rules={[{ required: true }]}
                    >
                      <FilterImpactTypeSelect />
                    </Form.Item>
                  </Col>
                </Row> */}
              </Col>
              <Col xs={24} lg={2}>
                <Button type='primary' htmlType='submit' loading={loading}>
                  {t('Search')}
                </Button>
              </Col>
            </Row>
          </Form>

          <Row justify='space-between'>
            <Col></Col>
            <Col>
              <Space>
                <Button
                  type='primary'
                  size='middle'
                  loading={loading}
                  disabled={_.isEmpty(rowData)}
                  onClick={async () => {
                    try {
                      const data = [
                        {
                          sheet: 'MonthlyReport',
                          columns: _.map(rowData?.[0], (value, label) => {
                            return { label, value: label }
                          }),
                          content: rowData,
                        },
                      ]

                      const settings = {
                        fileName: 'MonthlyReport', // Name of the spreadsheet
                        // extraLength: 3, // A bigger number means that columns will be wider
                        // writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
                      }

                      await xlsx(data, settings)
                    } catch (error) {
                      notification.error({
                        message: 'Failed',
                        description: error.message,
                      })
                    } finally {
                    }
                  }}
                >
                  {t('Export Excel')}
                </Button>
              </Space>
            </Col>
          </Row>

          <Card
            loading={loading}
            // titleExtra={
            //   <Select
            //     mode="multiple"
            //     placeholder={t('Select Number Attributes')}
            //     options={_.map(filterreportAttributes, (filterreportAttribute) => {
            //       return {
            //         label: filterreportAttribute?.report_type_attribute_name,
            //         value: filterreportAttribute?.report_type_attribute_id,
            //       }
            //     })}
            //     style={{ minWidth: 200 }}
            //   />
            // }
          >
            <div style={{ width: '100%', height: 600 }}>
              <PivotTable
                rowData={rowData}
                columns={_.map(rowData?.[0], (value, field) => {
                  return {
                    field,
                    enableRowGroup: !_.isNumber(value),
                    enablePivot: !_.isNumber(value),
                    enableValue: _.isNumber(value),
                  }
                })}
              />
            </div>
          </Card>
        </Space>
      </Page>
    </Styled>
  )
}
